webpackJsonp([192551386620669],{

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Util = __webpack_require__(9);
	var React = __webpack_require__(1);
	var ReasonReact = __webpack_require__(5);
	var SponsorTierModuleScss = __webpack_require__(451);
	
	var component = ReasonReact.statelessComponent("SponsorTier");
	
	function make(tier, _) {
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */component[/* didMount */4],
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      var match = tier[/* id */0];
	      var className;
	      switch (match) {
	        case "main":
	          className = SponsorTierModuleScss.main;
	          break;
	        case "regular":
	          className = SponsorTierModuleScss.regular;
	          break;
	        case "supporter":
	          className = SponsorTierModuleScss.supporter;
	          break;
	        default:
	          className = SponsorTierModuleScss.root;
	      }
	      var href = "mailto:hi@reason-conf.com?subject=Sponsoring: " + tier[/* name */1];
	      return React.createElement("a", {
	        className: className,
	        href: href
	      }, React.createElement("header", {
	        className: SponsorTierModuleScss.header
	      }, React.createElement("h3", {
	        className: SponsorTierModuleScss.name
	      }, Util.s(tier[/* name */1])), React.createElement("div", {
	        className: SponsorTierModuleScss.amount
	      }, React.createElement("h4", {
	        className: SponsorTierModuleScss.cost
	      }, Util.s(String(tier[/* cost */2]))), Util.s("€"))), React.createElement("section", {
	        className: SponsorTierModuleScss.description
	      }, Util.md(tier[/* description */4])));
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	exports.component = component;
	exports.make = make;
	/* component Not a pure module */

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----sponsorTier-module---root---2Qtmw","main":"src-components----sponsorTier-module---main---wKKNA src-components----sponsorTier-module---root---2Qtmw","regular":"src-components----sponsorTier-module---regular---176eI src-components----sponsorTier-module---root---2Qtmw","supporter":"src-components----sponsorTier-module---supporter---867fc src-components----sponsorTier-module---root---2Qtmw","header":"src-components----sponsorTier-module---header---2sU9y","name":"src-components----sponsorTier-module---name---1uov3","amount":"src-components----sponsorTier-module---amount---1soo5","cost":"src-components----sponsorTier-module---cost---1W4lJ","description":"src-components----sponsorTier-module---description---29k8K"};

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Data = __webpack_require__(23);
	var Util = __webpack_require__(9);
	var $$Array = __webpack_require__(24);
	var React = __webpack_require__(1);
	var ReasonReact = __webpack_require__(5);
	var SponsorTier = __webpack_require__(288);
	
	var component = ReasonReact.statelessComponent("Sponsors");
	
	function make() {
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */component[/* didMount */4],
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      return React.createElement("section", undefined, React.createElement("h1", undefined, Util.s("For Sponsors")), React.createElement("main", {
	        className: "leadText"
	      }, Util.md("\nReasonConf is the _world\'s first_ conference for\n[ReasonML](https://reasonml.github.io), a new language on top of OCaml\ndesigned to build highly efficient and type-safe React applications.\n")), React.createElement("main", undefined, Util.md("\nAlthough ReasonML is considered early tech, the conference has gained\nquite some attention and support from JavaScript community around the\nworld:\n\n- The [announcement\n  tweet](https://twitter.com/reasonconf/status/954084342086717441)\n  received **143,581** impressions, **400** likes, and attracted\n  **361** followers\n- We get support by leading Reason contributors as speakers and mentors\n- We invited guests from the OCaml industry, such as Facebook, Bloomberg, JaneStreet & OCaml Labs\n- Our Early Bird Tickets were **sold out in just two days**\n\nReasonConf is a **not-for-profit** conference. [The goal of the\nevent](/about/) is to bring the global community together. Around half\nof the tickets are provided to our international communities and\nnotable contributors to the Reason ecosystem.\n          ")), React.createElement("section", {
	        className: "grid--6col grid grid_6cols"
	      }, React.createElement("section", {
	        className: "grid--3col"
	      }, Util.md("\n## ReasonConf Facts\n\n- **Three day event** with practical workshops and a single track conference\n- We expect **180 attendees**, including speakers and volunteers\n- Speakers include **leading members and visionaries** of the ReasonML, JavaScript, and OCaml communities\n- **International audience** with a strong focus on web-development with React\n- Part of [**Diversity Tickets**](https://diversitytickets.org) by Travis Foundation\n          ")), React.createElement("section", {
	        className: "grid--3col"
	      }, Util.md("\n## 5 Reasons to Sponsor\n\n1. High brand exposure to a highly skilled and self-motivated crowd of\n   React, JavaScript & OCaml developers\n1. Good networking possibilities and first level connection with the ReasonML community leaders\n1. Improve the skillset of your developers and teach them new ways to improve code-quality of\n   your React & JavaScript applications\n1. Show off Vienna as an attractive hotspot for leading technology\n1. Get a headstart in a high potential technology (while building on\n   the enterprise-ready OCaml platform)\n          "))), React.createElement("h2", undefined, Util.s("Sponsor Tiers")), React.createElement("main", {
	        className: "full sponsor-tiers"
	      }, $$Array.map(function (tier) {
	        return ReasonReact.element( /* Some */[tier[/* id */0]], /* None */0, SponsorTier.make(tier, /* array */[]));
	      }, Data.Tier[/* sponsorTiers */0])), React.createElement("main", undefined, Util.md("\nIf you\'re interested in sponsoring the event, please [contact us](/contact/). If you want to\ncollaborate on ideas which are not covered by our sponsor plans, please let us know!\n          ")));
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	var $$default = ReasonReact.wrapReasonForJs(component, function (jsProps) {
	  return make(jsProps.children);
	});
	
	exports.component = component;
	exports.make = make;
	exports.$$default = $$default;
	exports.default = $$default;
	exports.__esModule = true;
	/* component Not a pure module */

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sponsors-js-8ddab98231644240bf7d.js